export default __webpack_public_path__ + "static/media/Icon-List-Added.ece15e08.svg";